import * as React from "react";

import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { GrowerMarketerUpdate, NatureOfRelationship, OneToManyDiscardedFlag } from "../../../model/ConfirmUpdate";
import { ApplicationStore } from "../../../stores/ApplicationStore";
import InputField from "../form-elements/InputField";
import { EmptyGroup } from "../form-elements/SimpleFormComponents";

export interface State {
    seelingSideRoadStandPercentage: string;
}

interface Props {
    applicationStore?: ApplicationStore;
    value: GrowerMarketerUpdate & OneToManyDiscardedFlag;
    loading?: boolean;
    disabled?: boolean;
    synchronizeValue?: boolean;
    onFieldChange: (fieldName: string, newValue: string | number | null) => any;
}

export default class TraceabilityCodeGrowerMarketerWidget extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            seelingSideRoadStandPercentage: ""
        };
    }

    render() {
        const onChange = (fieldName: string, newValue: string | number | null) => {
            if (this.props.loading) {
                return;
            }
            this.props.onFieldChange(fieldName, newValue);
        };

        const disabledCalculated = this.props.disabled || /*this.props.loading ||*/ this.props.value.discarded;
        const strikethrough = !!this.props.value.discarded;

        return (
            <div style={{ backgroundColor: "#f4f4f4" }}>
                <button className="btn btn-sm btn-info one-to-many-delete-button">
                    <FontAwesomeIcon icon={faTimesCircle} />
                </button>
                <div className="card-body pl-0 py-0 ">
                    <form onSubmit={e => e.preventDefault()}>
                        <div className="form-row mb-0">
                            <EmptyGroup label="Marketer Name:" name="marketer" className="col-md-12 col-lg-6" isRequired={true}>
                                <InputField
                                    fieldName="marketer"
                                    value={this.props.value.marketer || ""}
                                    synchronizeValue={this.props.synchronizeValue}
                                    onBlur={(newValue: string) => onChange("marketer", newValue)}
                                    disabled={disabledCalculated}
                                    strikethrough={strikethrough}
                                />
                            </EmptyGroup>
                            <EmptyGroup label="Percentage:" name="percentage" className="col-md-12 col-lg-6" isRequired={true}>
                                <div className="d-flex">
                                    <InputField
                                        fieldName="percentage"
                                        type="number"
                                        value={this.props.value.percentage || ""}
                                        synchronizeValue={this.props.synchronizeValue}
                                        onBlur={(newValue: string) => onChange("percentage", newValue)}
                                        disabled={disabledCalculated}
                                        strikethrough={strikethrough}
                                    />
                                    <div className="input-group-prepend" style={{ position: "relative", left: "-1px" }}>
                                        <div className="input-group-text" style={{ borderRadius: "0 .25rem .25rem 0" }}>
                                            %
                                        </div>
                                    </div>
                                </div>
                            </EmptyGroup>
                            <EmptyGroup label="Traceability Codes:" name="codes" className="col-md-12 col-lg-6" isRequired={true}>
                                <InputField
                                    fieldName="codes"
                                    value={this.props.value.codes || ""}
                                    synchronizeValue={this.props.synchronizeValue}
                                    onBlur={(newValue: string) => onChange("codes", newValue)}
                                    disabled={disabledCalculated}
                                    strikethrough={strikethrough}
                                />
                            </EmptyGroup>
                            <div className="col-md-12 col-lg-6">
                                <label htmlFor="">
                                    Nature of Relationship:<span className="text-danger"> * </span>
                                </label>
                                <div className="row pt-1">
                                    <div className="col-6">
                                        <label className="">
                                            <input
                                                className="mr-2 ml-3"
                                                type="radio"
                                                name="relationship"
                                                disabled={disabledCalculated}
                                                checked={this.props.value.relationship === NatureOfRelationship.CONTRACT}
                                                onChange={() => onChange("relationship", NatureOfRelationship.CONTRACT)}
                                            />
                                            &nbsp; Contract
                                        </label>
                                    </div>
                                    <div className="col-6">
                                        <label>
                                            <input
                                                className="mr-2"
                                                type="radio"
                                                name="relationship"
                                                disabled={disabledCalculated}
                                                checked={
                                                    (this.props.value as GrowerMarketerUpdate).relationship === NatureOfRelationship.NOT_CONTRACT
                                                }
                                                onChange={() => onChange("relationship", NatureOfRelationship.NOT_CONTRACT)}
                                            />
                                            &nbsp; Non-Contract
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
